import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerOfflineShell } from "./lib/offline-client";

void registerOfflineShell().catch(error => console.warn("Offline app preparation failed:", error));

createRoot(document.getElementById("root")!).render(<App />);
